import React from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "../../components/AdminHeader";
import { useTheme } from "../../contexts/ThemeContext";

const AdminLayout = () => {
  const { isDark } = useTheme();
  return (
    <div
      className={
        `min-h-screen flex flex-col transition-colors duration-250 ` +
        (isDark ? 'bg-gray-900' : 'bg-[#F8F9FA]')
      }
    >
      {/* Admin Top Header */}
      <AdminHeader />

      {/* Body — sidebar fixed, content scrolls */}
      <div className="flex flex-1 overflow-hidden">
        {/* Left Sidebar — fixed height below header */}
        <div className="h-[calc(100vh-64px)] overflow-y-auto flex-shrink-0 dark:bg-gray-800">
          <AdminSidebar />
        </div>

        {/* Page Content — scrolls independently */}
        <main className="flex-1 overflow-y-auto h-[calc(100vh-64px)] bg-white dark:bg-gray-900 transition-colors duration-250">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
